/* Emelsy product page (emx): gallery, bundles + subscription, sticky bar, slider */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function sticky() { return $('[data-emx-sticky]'); }

  document.addEventListener('emx:price', function (e) {
    var st = sticky();
    if (!st || !e.detail) return;
    var el = $('[data-emx-sticky-price]', st);
    if (el && e.detail.price) el.textContent = e.detail.price;
    var btn = $('[data-emx-sticky-btn]', st);
    if (btn) btn.disabled = !e.detail.available;
  });

  function initGallery(root) {
    $$('[data-emx-gallery]', root).forEach(function (g) {
      if (g.__emx) return; g.__emx = true;
      var slides = $$('[data-emx-slide]', g);
      var thumbs = $$('[data-emx-thumb]', g);
      if (slides.length < 2) {
        $$('[data-emx-prev],[data-emx-next]', g).forEach(function (b) { b.hidden = true; });
        return;
      }
      var i = 0;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          s.hidden = k !== i;
          if (k !== i) { var v = s.querySelector('video'); if (v) { try { v.pause(); } catch (err) {} } }
        });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === i);
          if (k === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
        });
        var th = thumbs[i], row = th && th.parentElement;
        if (row && row.scrollTo) row.scrollTo({ left: th.offsetLeft - row.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = $('[data-emx-prev]', g), next = $('[data-emx-next]', g);
      if (prev) prev.addEventListener('click', function () { show(i - 1); });
      if (next) next.addEventListener('click', function () { show(i + 1); });
      var main = $('.emx-gal__main', g), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
    });
  }

  function initBuy(root) {
    $$('[data-emx-buy]', root).forEach(function (box) {
      if (box.__emx) return; box.__emx = true;
      var dataEl = $('[data-emx-tiers]', box);
      var tiers = [];
      try { tiers = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { tiers = []; }
      var tierInputs = $$('input[data-emx-tier]', box);
      var planInputs = $$('input[name="emx_plan"]', box);
      var sp = $('[data-emx-selling-plan]', box);
      function fill(tpl, t) { return (tpl || '').replace(/\[discount\]/g, t.pct).replace(/\[interval\]/g, t.interval || ''); }
      function setText(r, sel, val) { var el = $(sel, r); if (el && val != null) el.textContent = val; }
      function update() {
        if (!tiers.length) return;
        var ti = 0;
        tierInputs.forEach(function (x, k) { if (x.checked) ti = k; });
        var planIn = planInputs.filter(function (x) { return x.checked; })[0];
        var wantSub = planIn ? planIn.value === 'sub' : false;
        tierInputs.forEach(function (inp, k) {
          var d = tiers[k]; if (!d) return;
          var m = (wantSub && d.plan && k === ti) ? d.s : d.o; /* only the selected bundle shows the subscription price */
          var card = inp.closest('.emx-tier');
          if (!card) return;
          setText(card, '[data-emx-t="price"]', m.price);
          setText(card, '[data-emx-t="compare"]', m.compare);
          setText(card, '[data-emx-t="save"]', m.save);
          setText(card, '[data-emx-t="detail"]', m.detail);
          var sv = $('[data-emx-t="save"]', card), cv = $('[data-emx-t="compare"]', card);
          if (sv) sv.hidden = !m.hasSave;
          if (cv) cv.hidden = !m.hasSave;
        });
        var t = tiers[ti] || tiers[0];
        var plansBox = $('[data-emx-plans]', box);
        if (plansBox) plansBox.hidden = !t.plan; /* subscription only for bundles that have a plan */
        var useSub = wantSub && !!t.plan;
        var m = useSub ? t.s : t.o;
        if (sp) sp.value = useSub ? t.plan : '';
        setText(box, '[data-emx-sub-price]', t.s.price);
        setText(box, '[data-emx-once-price]', t.o.price);
        setText(box, '[data-emx-sub-title]', fill(box.getAttribute('data-sub-title'), t));
        setText(box, '[data-emx-sub-sub]', fill(box.getAttribute('data-sub-sub'), t));
        setText(box, '[data-emx-sub-note]', fill(box.getAttribute('data-sub-note'), t));
        var btn = $('[data-emx-atc]', box), lbl = $('[data-emx-atc-label]', box), was = $('[data-emx-atc-was]', box);
        if (btn) btn.disabled = !t.available;
        if (lbl) lbl.textContent = t.available ? (box.getAttribute('data-atc-label') || 'Add to cart') + ' — ' + m.price : (box.getAttribute('data-soldout') || 'Sold out');
        if (was) { was.textContent = m.compare; was.hidden = !m.hasSave || !t.available; }
        $$('[data-emx-note="sub"]', box).forEach(function (n) { n.hidden = !useSub; });
        $$('[data-emx-note="once"]', box).forEach(function (n) { n.hidden = useSub; });
        document.dispatchEvent(new CustomEvent('emx:price', { detail: { price: m.price, available: t.available } }));
      }
      tierInputs.forEach(function (x) { x.addEventListener('change', update); });
      planInputs.forEach(function (x) { x.addEventListener('change', update); });
      update();
    });
  }

  /* Sticky bar: visible only once the main Add to cart button has scrolled above the screen. */
  function initSticky() {
    var st = sticky();
    if (!st || st.__emx) return; st.__emx = true;
    var ticking = false;
    function check() {
      ticking = false;
      var bar = sticky();
      if (!bar) return;
      var atc = $('[data-emx-atc]');
      bar.classList.toggle('is-visible', atc ? atc.getBoundingClientRect().bottom < 0 : true);
    }
    function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  }

  function initBA(root) {
    $$('[data-emx-ba]', root).forEach(function (w) {
      var r = $('input[type="range"]', w);
      if (!r || w.__emx) return; w.__emx = true;
      function set() { w.style.setProperty('--emx-pos', r.value + '%'); }
      r.addEventListener('input', set);
      set();
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (target && target.tagName === 'DETAILS') target.open = true;
  });

  function initAll(root) { initGallery(root); initBuy(root); initBA(root); initSticky(); }
  initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
